import { axiosInstance } from "contexts/axiosApiInstance";
import { EditTeamRequest, TeamDetails } from "target_wasm";
import { useTeamsStore } from "@/components/main/stores/teamsStore";
import { editTeam } from "@/components/main/utils/teams/TeamsApi";

export interface DescriptionData {
  description: string;
  updated_by: string | null;
  updated_at: number | null;
}

export async function fetchModelDescription(
  modelId: string,
): Promise<DescriptionData> {
  const response = await axiosInstance.get(
    `/action/model/${modelId}/description`,
  );
  return response.data;
}

export async function updateModelDescription(
  modelId: string,
  description: string,
): Promise<void> {
  await axiosInstance.put(`/action/model/${modelId}/description`, {
    description,
  });
}

// No model id on either call: a table has one description keyed by its own id,
// and the server authorizes the write against the table's real owning model.
export async function fetchTableDescription(
  tableId: string,
): Promise<DescriptionData> {
  const response = await axiosInstance.get(
    `/action/table/${tableId}/description`,
  );
  return response.data;
}

export async function updateTableDescription(
  tableId: string,
  description: string,
): Promise<void> {
  await axiosInstance.put(`/action/table/${tableId}/description`, {
    description,
  });
}
export function fetchTeamDescription(teamId: string): DescriptionData {
  const team = useTeamsStore
    .getState()
    .teams.find((t) => t.team_id_str() === teamId);
  const details = team?.team_details_js();
  return {
    description: details?.team_description_js() ?? "",
    updated_by: null,
    // No description-specific timestamp on TeamDetails.
    updated_at: null,
  };
}

export async function updateTeamDescription(
  teamId: string,
  description: string,
): Promise<void> {
  const team = useTeamsStore
    .getState()
    .teams.find((t) => t.team_id_str() === teamId);
  if (!team) throw new Error(`Team ${teamId} not found in store`);
  const details = team.team_details_js();
  const newDetails = new TeamDetails(
    details.team_name_js(),
    description,
    details.team_color_js(),
    details.team_asset_js(),
    BigInt(Date.now()),
  );
  const updated = await editTeam(EditTeamRequest.new_js(teamId, newDetails));
  useTeamsStore.getState().updateTeam(updated);
}
